import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { PiBagFill } from "react-icons/pi";
import { useForm } from "react-hook-form";
import MilestoneComments from "./MilestoneComments";
import MilestoneActivityStream from "./MilestoneActivity";
import MilestoneStatusTimeline from "./MilestoneStatus";
import MilestoneTasklist from "./MilestoneTasklist";
import MilestoneIssue from "./MilestoneIssue";
import MilestoneLogs from "./MilestoneLogs";
import { useTheme } from "../../../ThemeContext";
import {
  useFetchGetallMilestoneCommentsQuery,
  useFetchMilestoneDetailsQuery,
  useFetchMilestoneIssuesQuery,
} from "../../../slice/logdetailSlice";


// const MilestoneTabs = ({ comments_length }) => {
const MilestoneTabs = ({ comments_length, issues_length, projectId, milestoneName }) => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(() => {
    return sessionStorage.getItem(`milestone_active_tab_${id}`) || "TasksLists";
  });

  // Set milestoneLogsActivated based on activeTab
  const [milestoneLogsActivated, setMilestoneLogsActivated] = useState(
    () => sessionStorage.getItem(`milestone_active_tab_${id}`) === "MilestoneLogs"
  );

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    sessionStorage.setItem(`milestone_active_tab_${id}`, tabId);
    if (tabId === "MilestoneLogs") {
      setMilestoneLogsActivated(true);
    }
  };

  return (
    <div className="mt-3 ">
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item pe-4" role="presentation">
          <button
            className={`${activeTab === "TasksLists" ? "active" : ""} text-rgba-gray R_btn`}
            id="TasksLists-tab"
            onClick={() => handleTabClick("TasksLists")}
            type="button"
            role="tab"
            aria-selected={activeTab === "TasksLists"}
          >
            Tasks Lists
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className={`${activeTab === "Issues" ? "active" : ""} text-rgba-gray R_btn`}
            id="Issues-tab"
            onClick={() => handleTabClick("Issues")}
            type="button"
            role="tab"
            aria-selected={activeTab === "Issues"}
          >
            Issues ({issues_length})
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className={`${activeTab === "Comments" ? "active" : ""} text-rgba-gray R_btn`}
            id="Comments-tab"
            onClick={() => handleTabClick("Comments")}
            type="button"
            role="tab"
            aria-selected={activeTab === "Comments"}
          >
            Comments ({comments_length})
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className={`${activeTab === "MilestoneStatusTimeline" ? "active" : ""} text-rgba-gray R_btn`}
            id="MilestoneStatusTimeline-tab"
            onClick={() => handleTabClick("MilestoneStatusTimeline")}
            type="button"
            role="tab"
            aria-selected={activeTab === "MilestoneStatusTimeline"}
          >
            Status Timeline
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className={`${activeTab === "ActivityStream" ? "active" : ""} text-rgba-gray R_btn`}
            id="ActivityStream-tab"
            onClick={() => handleTabClick("ActivityStream")}
            type="button"
            role="tab"
            aria-selected={activeTab === "ActivityStream"}
          >
            Activity Stream
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className={`${activeTab === "MilestoneLogs" ? "active" : ""} text-rgba-gray R_btn`}
            id="MilestoneLogs-tab"
            onClick={() => handleTabClick("MilestoneLogs")}
            type="button"
            role="tab"
            aria-selected={activeTab === "MilestoneLogs"}
          >
            Milestone Logs
          </button>
        </li>
      </ul>

      <div className="tab-content" id="myTabContent">
        <div
          className={`tab-pane fade ${activeTab === "TasksLists" ? "show active" : ""}`}
          id="TasksLists"
          role="tabpanel"
          aria-labelledby="TasksLists-tab"
        >
          <MilestoneTasklist />
        </div>

        <div
          className={`tab-pane fade ${activeTab === "Issues" ? "show active" : ""}`}
          id="Issues"
          role="tabpanel"
          aria-labelledby="Issues-tab"
        >
          <MilestoneIssue />
        </div>

        <div
          className={`tab-pane fade ${activeTab === "Comments" ? "show active" : ""}`}
          id="Comments"
          role="tabpanel"
          aria-labelledby="Comments-tab"
        >
          <MilestoneComments />
        </div>

        <div
          className={`tab-pane fade ${activeTab === "MilestoneStatusTimeline" ? "show active" : ""}`}
          id="MilestoneStatusTimeline"
          role="tabpanel"
          aria-labelledby="MilestoneStatusTimeline-tab"
        >
          <MilestoneStatusTimeline />
        </div>

        <div
          className={`tab-pane fade ${activeTab === "ActivityStream" ? "show active" : ""}`}
          id="ActivityStream"
          role="tabpanel"
          aria-labelledby="ActivityStream-tab"
        >
          <MilestoneActivityStream />
        </div>

        <div
          className={`tab-pane fade ${activeTab === "MilestoneLogs" ? "show active" : ""}`}
          id="MilestoneLogs"
          role="tabpanel"
          aria-labelledby="MilestoneLogs-tab"
        >
          {milestoneLogsActivated && (
            <MilestoneLogs
              milestoneName={milestoneName}
              projectId={projectId}
              milestoneId={id}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const MilestoneDetail = () => {
  const { isDarkMode } = useTheme();
  const [MilestoneTasklist, setMilestoneTasklist] = useState([]);
  const [milestoneName, setMilestoneName] = useState("");
  const [projectName, setProjectName] = useState("");

  const [headanchorEl, setheadAnchorEl] = useState(null);
  const navigate = useNavigate();
  const { id, project_id } = useParams();
  const { data, refetch: milestone_comments } =
    useFetchGetallMilestoneCommentsQuery(id);
  const { data: milestone_detail } = useFetchMilestoneDetailsQuery(id);
  const { data: milestone_issues } = useFetchMilestoneIssuesQuery(id);
  //console.log()("milestone_comments :", data?.length);
  // useEffect(() => {
  //   if (id) localStorage.setItem("milestoneId", id);

  //   const fetchData = async () => {
  //     try {
  //       const { status, milestone_name, project_name, data } =
  //         await fetchEntityById("milestones/tasklist", id);

  //       if (status) {
  //         setMilestoneName(milestone_name || "");
  //         setProjectName(project_name || "");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching tasks:", error);
  //     }
  //   };

  //   fetchData();
  // }, [id]);

  useEffect(() => {
    if (milestone_detail) {
      setMilestoneTasklist(milestone_detail.data || []);
      // Support both field names that the API might return
      const mName =
        milestone_detail.milestone_name ||
        milestone_detail.name ||
        milestone_detail.data?.[0]?.milestone_name ||
        "";
      setMilestoneName(mName);
      milestone_comments();
    }
  }, [milestone_detail]);

  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };

  const handleClick = (event) => {
    setheadAnchorEl(event.currentTarget);
  };

  const HeadhandleClose = () => {
    setheadAnchorEl(null); // Ensure this sets the anchor element to null to close the menu
  };

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      projectName: "",
      owner: "",
      createdBy: "",
      Duedate: null,
      endDate: null,
      status: "",
    },
  });

  const onSubmit = (data) => {
    //console.log()(data);
  };
  //console.log()("MilestoneTasklist :", projectName);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center bg-white mb-3  p-3 border-bottom rounded-bottom">
        <div>
          {/* <Typography variant="h5" gutterBottom>{task.taskName}</Typography> */}
          <div className="d-flex align-items-center gap-2">
            <button className="R_btn " onClick={handleBackClick} style={{ cursor: "pointer" }}>
              <IoIosArrowBack size={18} className="text-rgba-gray" />
            </button>

            <label className="text-rgba-gray m-0 d-flex align-items-center gap-1" style={{ color: isDarkMode ? "#a0aec0" : undefined }}>
              <PiBagFill className="text-rgba-gray me-1" style={{ color: isDarkMode ? "#a0aec0" : undefined }} />
              Project Name: <span className={`fw-semibold ms-1 ${isDarkMode ? "text-white" : "text-dark"}`}>{milestone_detail?.project_name}</span>
            </label>

            <span className="text-rgba-gray border-start ps-3 py-1" style={{ color: isDarkMode ? "#a0aec0" : undefined }}>
              Milestone Name: <span className={`fw-semibold ms-1 ${isDarkMode ? "text-white" : "text-dark"}`}>{milestone_detail?.milestone_name}</span>
            </span>
          </div>
        </div>
        
        <div className="d-flex align-items-center">
          <div className="ps-3">
            {/* <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <BsThreeDots />
            </IconButton> */}
            {/* <Menu
              id="long-menu"
              anchorEl={headanchorEl}
              open={Boolean(headanchorEl)}
              onClose={HeadhandleClose}
              PaperProps={{
                style: {
                  maxHeight: 48 * 4.5,
                  width: "20ch",
                },
              }}
            >
              <MenuItem>Edit</MenuItem>
              <MenuItem>Delete</MenuItem>
              <MenuItem>Clone</MenuItem>
              <MenuItem>Copy Link</MenuItem>
            </Menu> */}
          </div>
        </div>
      </div>

      <div className="row bg-white p-3">
        <div className="col-md-12">
          {/* <MilestoneTabs comments_length={data?.length} /> */}
          <MilestoneTabs
            comments_length={data?.length}
            issues_length={milestone_issues?.length || 0}
            projectId={project_id}
            milestoneName={milestoneName}
          />
        </div>
      </div>
    </div>
  );
};

export default MilestoneDetail;
